import { useState } from "react";

import { Chessboard } from "@/components/Chessboard";
import { GamePlyData } from "@/gen/realtime";
import { GameReport } from "@/hooks/useRealtimeGame";

export const LiveChessboard = ({
    gameReport,
    plyData,
}: {
    gameReport: GameReport | null;
    plyData: GamePlyData;
}) => {
    const [chessboardPlyIndex, setChessboardPlyIndex] = useState(plyData.plies.length - 1);

    return (
        <Chessboard
            gameReport={gameReport}
            plyData={plyData}
            plyIndex={chessboardPlyIndex}
            setPlyIndex={setChessboardPlyIndex}
            enableAnalysis={true}
        />
    );
};
